import React from "react";

const Blog4 = ({ blog }) => {
  return (
    <div className="parent-container">
      <div className="main-container-blogpage" id="blog-content-container">
        <div className="category-tag">{blog.category}</div>
        <p className="headline-page">{blog.mainTitlePage}</p>
        <p className="date">{blog.publishDate}</p>
        <div className="image-container">
          <img className="img" src={blog.detailImage} alt={blog.imageAlt} />
        </div>

        <p className="paragraph-content">
          as of date 31st December 2023 kPaisa has <b>52,782</b> users who are
          actively using the{" "}
          <a
            href="https://kleio.app.link/download"
            style={{
              color: "#000103ff",
              textDecoration: "underline",
              fontWeight: "bold",
            }}
          >
            kPaisa
          </a>{" "}
          App.
          <br />
          This Article Consolidates all our learning from the past 2 years which
          we spent on building kPaisa chronicling the highs and lows, numerous
          pivots, user feedback loops, and the unique challenges we faced. It’s
          a blend of our dedication, sleepless nights, and the profound learning
          that came from understanding and addressing user needs. If our
          experiences and mistakes can teach you something, it might help you
          save valuable time! We’ve learned a lot while building kPaisa, and we
          hope sharing our journey can make your path a bit smoother
        </p>

        <p
          className="sub-paragraph-heading"
          style={{ color: "black", fontSize: "18px", fontWeight: 500 }}
        >
          - <i> Things that worked for us </i>
        </p>

        <p
          className="sub-paragraph-heading"
          style={{ color: "black", fontWeight: 600 }}
        >
          - Refining the MVP
        </p>
        <p className="sub-paragraph-heading">Integrating User Feedback</p>

        <p className="sub-paragraph-content">
          After the beta launch of our MVP, the most exciting phase unfolded:
          the interaction with our users. Their feedback, raw and unfiltered,
          became the guiding light for our next steps, along with our exhaustive
          research. It was not just about fixing bugs in the App but
          understanding the complexity of their needs, refining features, and
          strengthening the overall user experience.
        </p>

        <p className="sub-paragraph-heading">Data-Driven Decision Making</p>

        <p className="sub-paragraph-content">
          We used to often hear that numbers speak, and we had a firsthand
          experience of this during the beta testing of the app. We immersed
          ourselves in analytics, dissecting user behaviour and product metrics.
          However, it was a small exercise for us, given that we had a limited
          1000 beta users on the app. This analytical approach wasn’t just about
          charts and graphs; it was about understanding the cream, the most-used
          feature, or the most loved aspect of our product and making decisions
          based on real-world insights.
        </p>

        <p
          className="sub-paragraph-heading"
          style={{ color: "black", fontWeight: 600 }}
        >
          - Monetization Strategies
        </p>
        <p className="sub-paragraph-heading">Value-Added Features</p>

        <p className="sub-paragraph-content">
          Our journey wasn’t just about fixing what was broken; it was about
          elevating the experience. We identified areas where we could add
          value, crafting premium features that spoke directly to our users’
          desires. This wasn’t just about revenue; it was about delivering more
          than what was expected. For example- we provide users with a premium
          AI-powered expense management tool within the App, allowing them to
          keep track of their finances, It seamlessly integrates within your
          system and calculates all your expenses that you have spent throughout
          the M/D/Y to help you make informed decisions.
        </p>

        <p className="sub-paragraph-heading">Alternative Revenue Paths</p>

        <p className="sub-paragraph-content">
          As a user-centric Mobile app, our primary focus is on providing a
          valuable and hassle-free service to our users. While we don’t charge
          users directly, we explore alternative revenue paths, such as
          strategic partnerships, sponsored content, or premium partnerships
          with brands, which creates a WIN-WIN-WIN for all of Us, Users and
          Brands. These approaches allow us to sustain our business and create
          more exciting features for our users.
        </p>

        <p
          className="sub-paragraph-heading"
          style={{ color: "black", fontWeight: 600 }}
        >
          User Acquisition and Retention
        </p>
        <p className="sub-paragraph-heading">Almost Rs 0 CAC</p>

        <p className="sub-paragraph-content">
          Yes, you read that right we have almost Rs 0 CAC (Customer Acquisition
          cost) being a Bootstrapped company we don't have the budget to spend
          heavy bucks on Marketing so we decided to have our very own strategy
          to Acquire users.
        </p>
      </div>
    </div>
  );
};

export default Blog4;
